export const saveTransferInProgress = (state) =>
  state?.temp?.transfer?.saveTransferInProgress ?? false;

export const saveTransferCompleted = (state) =>
  state?.temp?.transfer?.saveTransferCompleted ?? false;
